module.exports = __webpack_public_path__ + "img/actived-circle.064d1f33.svg";